/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ocr_Complete_TextInputs */

const en_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Found ${i?.count} text segments. How would you like to import the results?`)
};

const fr_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Des segments de texte ${i?.count} ont été trouvés. Comment souhaitez-vous importer les résultats ?`)
};

const de_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es wurden ${i?.count} Textsegmente gefunden. Wie möchten Sie die Ergebnisse importieren?`)
};

const it_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sono stati trovati ${i?.count} segmenti di testo. Come desideri importare i risultati?`)
};

const ru_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обнаружено ${i?.count} текстовых сегментов. Как вы хотите импортировать результаты?`)
};

const es_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se encontraron segmentos de texto ${i?.count}. ¿Cómo desea importar los resultados?`)
};

const zh_cn2_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`找到 ${i?.count} 个文本片段。您希望如何导入结果？`)
};

const ja_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個のテキストセグメントが見つかりました。結果をどのようにインポートしますか？`)
};

const hi_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} टेक्स्ट सेगमेंट मिले। आप परिणामों को कैसे आयात करना चाहेंगे?`)
};

const pt_pt2_ocr_complete_text = /** @type {(inputs: Ocr_Complete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foram encontrados ${i?.count} segmentos de texto. Como você gostaria de importar os resultados?`)
};

/**
* | output |
* | --- |
* | "Found {count} text segments. How would you like to import the results?" |
*
* @param {Ocr_Complete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete_text = /** @type {((inputs: Ocr_Complete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Complete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_complete_text(inputs)
	if (locale === "de") return de_ocr_complete_text(inputs)
	if (locale === "it") return it_ocr_complete_text(inputs)
	if (locale === "ru") return ru_ocr_complete_text(inputs)
	if (locale === "es") return es_ocr_complete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_complete_text(inputs)
	if (locale === "ja") return ja_ocr_complete_text(inputs)
	if (locale === "hi") return hi_ocr_complete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_complete_text(inputs)
	return en_ocr_complete_text(inputs)
});